import { IOnboardingDocuments } from '@efex-services/documents/documentsSvc';

export type ProofOfAddressDocumentReducerState = [IOnboardingDocuments] | [];

export interface ProofOfAddressDocumentReducerAction {
  type: ProofOfAddressDocumentReducerCases;
  payload?: IOnboardingDocuments[];
}

export enum ProofOfAddressDocumentReducerCases {
  SET_DOCUMENT = 'SET_DOCUMENT',
  DELETE_DOCUMENT = 'DELETE_DOCUMENT',
}
